const HeadlineSmall: React.FC<{}> = ({ children }) => (
  <h2 className="uppercase font-bold text-xs">{children}</h2>
);

export default HeadlineSmall;
